<template>
  <div class="st-file-picker-input">
    <StButton secondary :for="id" @click="invokeFileInput" ref="fileInputLabel">
      <StIcon name="upload" class="st-file-picker-input__icon" />
      {{ uploadBtnText }}
    </StButton>
    <input
      class="st-file-picker-input__input"
      :id="id"
      type="file"
      :accept="fileTypes"
      @change="emit('file-selected', $event)"
      tabindex="-1"
      ref="fileInput"
      :multiple="allowMultiple"
      :aria-describedby="ariaDescribedby"
    />
  </div>
</template>
<script setup>
import { computed, ref } from "vue";
import { StIcon, StButton } from "@/index";

const emit = defineEmits(["file-selected"]);

const fileInput = ref(null);
const fileInputLabel = ref(null);

const props = defineProps({
  acceptedFiletypes: {
    type: Array,
    default: () => [],
  },
  allowMultiple: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: "file-input",
  },
  ariaDescribedby: {
    type: String,
  },
  uploadBtnText: {
    type: String,
  },
});

const invokeFileInput = () => {
  fileInput.value.click();
};

const fileTypes = computed(() => {
  let files = "";
  props.acceptedFiletypes.forEach((type, i) => {
    const isLast = i === props.acceptedFiletypes.length - 1;
    files += `${type}${isLast ? "" : ","}`;
  });
  return files;
});

defineExpose({
  fileInputLabel,
});
</script>
<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-file-picker-input {
  &__icon {
    align-self: flex-end;
  }
  &__input {
    display: none;
  }
}
</style>
